import React from 'react';
import style from './contactsProfileInfo.module.css';

const ContactsProfileInfo = (props) => {
    return (
        <span className={style.container}>
            <p>Contacts:</p>
            {Object.keys(props.contacts).map((key, index) => {
                let newContact;
                if (props.contacts[key]) {
                    newContact =
                        (props.contacts[key].startsWith('https://')
                            || props.contacts[key].startsWith('http://'))
                            ? props.contacts[key]
                            : `http://${props.contacts[key]}`;
                }

                return (
                    <p key={index} className={style.contact}>
                        {`${key}: `}
                        {newContact
                            ? <a href={newContact}>{newContact}</a>
                            : 'none'}
                    </p>
                )
            })}
        </span>
    )
};

export default ContactsProfileInfo;